import { ApiBase } from './ApiBase';
class OffersGiftCardApiClientModel extends ApiBase {
    constructor() {
        super(...arguments);
        this.createOfferGiftCard = () => {
            return this.post('offers-gift-card');
        };
        this.getOfferGiftCard = (pathParams) => {
            return this.get(`offers-gift-card/${pathParams.offerId}`);
        };
        this.updateOfferGiftCard = (pathParams, payload) => {
            return this.put(`offers-gift-card/${pathParams.offerId}`, payload);
        };
    }
}
export const OffersGiftCardApiClient = new OffersGiftCardApiClientModel();
